import React, { useEffect, useState } from "react";
import { getDirectusClient } from "../../../lib/directus";
import { Button, Form, Input, Modal, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import { readItems } from "@directus/sdk";
import { useSelector } from "react-redux";
import { truncateSerial } from "../../../lib/utils";

function Serial(props) {
  const arrayp = props.productosagregados;
  const [seriales, setSeriales] = useState([]);
  const [productos, setProductos] = useState([]);
  const [form] = useForm();

  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const userRoleID = useSelector((state) => state.userdata.role?.name);
  const omitir1 = useSelector((state) => state.omitir1.omitir1);

  const onFinish = async (values) => {
    const directus = await getDirectusClient();

    const serialYaAgregado = arrayp.some(
      (item) => !item.isNonSerialized && item.serial === values.serial
    );

    if (serialYaAgregado) {
      Modal.warning({
        title: "Serial ya agregado",
        content: `El serial ${values.serial} ya ha sido agregado al préstamo. No se puede agregar el mismo serial dos veces.`,
      });
      return;
    }

    await directus
      .request(
        readItems("seriales", {
          fields: [
            "serial",
            "id",
            "producto.nombre",
            "producto.preciosinimp",
            "producto.grupo.impuesto",
            "producto.id",
            "estado.id",
            "estado.estado",
          ],
          filter: {
            serial: truncateSerial(values.serial, omitir1),
            estado: 1,
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                  bodega: {
                    id: { _eq: userBodega },
                  },
                }
              : {}),
          },
          limit: -1,
        })
      )
      .then((res) => {
        if (res.length <= 0) {
          Modal.error({
            title: "No se encontraron seriales con los datos suministrados",
          });
          return;
        }
        setSeriales(res);

        const newItems = res.map((item) => ({
          ...item,
          isNonSerialized: false,
        }));
        props.setProductosagregados((prev) => [...prev, ...newItems]);
      })
      .catch((err) => console.log(err));

    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {}, [arrayp]);

  return (
    <>
      <Form
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Space size="large" direction="vertical" style={{ display: "flex" }}>
          <Form.Item
            wrapperCol={{ offset: 8, span: 16 }}
            label="Serial"
            name="serial"
            rules={[{ required: true, message: "Please input your caja!" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button type="primary" htmlType="submit">
              procesar
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </>
  );
}

export default Serial;
